import { get, post } from './http-calls';

export const getqcJobs = async (start, end, id, MOTJob) => {
    let res = await get(`QCSheet/GetQCJobsDashboard?startDate=${start}&endDate=${end}&BranchId=${id}&MOTJob=${MOTJob}`, { useAuthToken: true });
    return res;
};
